export const materialSubCategory = [
    {
        data: "BOARD"
    },
    {
        data: "LAMINASI"
    },
    {
        data: "EDGING"
    },
    {
        data: "SOLID"
    },
    {
        data: "ADHESIVE"
    },
    {
        data: "ACCESSORIES"
    },
    {
        data: "CONNECTOR"
    },
    {
        data: "LIGHTING/ELECTRICAL"
    },
    {
        data: "FITTING"
    },
    {
        data: "PLUMBING"
    },
    {
        data: "FINISHING"
    },
    {
        data: "ABRASIVE"
    },
    {
        data: "OUTSOURCE"
    },
    {
        data: "PACKING"
    },
    {
        data: "CLEANING"
    }
]